<template>
    <div>
        <div class="top-box">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>管理员列表</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="tab-list d_flex a_c ">
                <h2>管理员列表</h2>
                <div class="item" @click="add"><i class="icon el-icon-circle-plus-outline" type="primary"></i>新增管理员</div>
            </div>
        </div>
        <div class="page-content p20">
            <div class="add-box bg_fff p20">
                <el-form :inline="true" class="demo-form-inline" size="mini" style="text-align: left">
                    <el-form-item label="管理员姓名" >
                        <el-input v-model="form.name" clearable style="width: 200px;" placeholder="管理员姓名" clearable @clear="list()"></el-input>
                    </el-form-item>
                    <el-form-item label="管理员电话" >
                        <el-input v-model="form.mobile" clearable style="width: 200px;" placeholder="管理员电话" clearable @clear="list()"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="list">查询</el-button>
                    </el-form-item>
                </el-form>
                <el-table :data="tableData" size="mini" border style="width: 100%"  v-loading="loading">
                    <el-table-column prop="" label="头像" align="center">
                        <template slot-scope="scope">
                            <img :src="scope.row.icon|handleImg" alt="" v-if="scope.row.icon" style="width: 50px;height: 50px;">
                            <span v-else>暂无头像</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="姓名" align="center"/>
                    <el-table-column prop="mobile" label="手机号" align="center"/>
                    <el-table-column prop="wx" label="微信" align="center"/>
                    <el-table-column prop="area" label="是否冻结" align="center">
                        <template slot-scope="scope">
                            <el-switch  v-model="scope.row.status==1" @change="changeStatus(scope.row)"></el-switch>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" align="center" width="180px">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="updateRow(scope.row)" >修改</el-button>
                            <el-button type="text" size="small" @click="deleRow(scope.row)" >删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="pages"
                        :current-page="page"
 :page-size="20"
                        @current-change="handleCurrentChange"
                        style="margin-top: 20px; text-align: right;"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import {manageList,manageDj,delManage} from '../../api/site'
    import { mapState } from 'vuex';
    export default {
        name: "m-list",
        data(){
            return{
                tableData:[],
                loading:false,
                page:1,
                pages:1,
                form:{
                    name:'',
                    mobile:''
                }
            }
        },
        created() {
            this.list();
        },
        computed:{
            ...mapState(['baseUrl'])
        },
        methods:{
            list(){
                this.loading=true;
                manageList({
                    ...this.form,
                    p:this.page,
                }).then(res=>{
                    this.loading=false;
                    if(res.code==1){
                        this.tableData=res.data.list;
                        this.pages=res.data.total_num;
                    }
                })
            },
            add(){
                this.$router.push({path: '/site/manage'});
            },
            handleCurrentChange(val){
                this.page = val;
                this.list();
            },
            updateRow(row){
                this.$router.push({path: '/site/manage',query:{id:row.id}});
            },
            deleRow(row){
                this.$confirm('此操作将永久删除该管理员, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delManage({id:row.id}).then(res=>{
                        if(res.code==1){
                            this.$message.success('操作成功')
                            this.list();
                        }else{
                            this.$message.error(res.msg)
                        }
                    })
                })
            },
            changeStatus(row){
                let status=1;
                if(row.status==1){
                    status=8
                }else{
                    status=1
                }
                manageDj({
                        id:row.id,
                        status:status,
                        is_show:1
                    }).then(res=>{
                    if(res.code==1){
                        this.$message.success('操作成功')
                        this.list();
                    }else{
                        this.$message.error(res.msg)
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
